export const EMOJI_CATEGORIES = {
    SMILEYS_AND_PEOPLE: 'Smileys & People',
    ANIMALS_AND_NATURE: 'Animals & Nature',
    FOOD_AND_DRINK: 'Food & Drink',
    TRAVEL_AND_PLACES: 'Travel & Places',
    ACTIVITIES: 'Activities',
    OBJECTS: 'Objects',
    SYMBOLS: 'Symbols',
};

export const EMOJI_CATEGORIES_LIST = Object.values(EMOJI_CATEGORIES);

export const EMOJI_CATEGORIES_I18N_KEYS = {
    [EMOJI_CATEGORIES.SMILEYS_AND_PEOPLE]: 'category_smileys_and_people',
    [EMOJI_CATEGORIES.ANIMALS_AND_NATURE]: 'category_animals_and_nature',
    [EMOJI_CATEGORIES.FOOD_AND_DRINK]: 'category_food_and_drink',
    [EMOJI_CATEGORIES.TRAVEL_AND_PLACES]: 'category_travel_and_places',
    [EMOJI_CATEGORIES.ACTIVITIES]: 'category_activities',
    [EMOJI_CATEGORIES.OBJECTS]: 'category_objects',
    [EMOJI_CATEGORIES.SYMBOLS]: 'category_symbols',
};

export const EMOJI_CATEGORIES_ICON_KEYS = {
    [EMOJI_CATEGORIES.SMILEYS_AND_PEOPLE]: 'face',
    [EMOJI_CATEGORIES.ANIMALS_AND_NATURE]: 'flower',
    [EMOJI_CATEGORIES.FOOD_AND_DRINK]: 'restaurant',
    [EMOJI_CATEGORIES.TRAVEL_AND_PLACES]: 'flight',
    [EMOJI_CATEGORIES.ACTIVITIES]: 'direction_run',
    [EMOJI_CATEGORIES.OBJECTS]: 'lightbulb_outline',
    [EMOJI_CATEGORIES.SYMBOLS]: 'notifications',
};

export const LEXEMES_EMOJI_MAP = {
    ':smile:': ['1f642'],
    ':+1:': ['1f44d'],
    ':-1:': ['1f44e'],
    ':heart:': ['2764'],
    ':tada:': ['1f389'],
    ':smiley:': ['1f60a'],
    ':neutral:': ['1f610'],
    ':surprised:': ['1f62e'],
    ':flushed:': ['1f633'],
    ':frustrated:': ['1f627'],
};

export const LEXEME_REGEXP = /(:[+\-\w\d]+:)/g;

/* eslint-disable max-len */
export const EMOJI_LIST_BY_CATEGORIES = {
    [EMOJI_CATEGORIES.SMILEYS_AND_PEOPLE]: [
        { name: 'Grinning Face', codes: ['1f600'], keywords: ['Улыбка', ':D', ':-D', ':)', ':-)'] },
        {
            name: 'Beaming Face With Smiling Eyes',
            codes: ['1f601'],
            keywords: ['Улыбка', ':))', ':D', ':‑D', 'X‑D', 'XD', 'Смех', 'Ха-ха'],
        },
        {
            name: 'Face With Tears of Joy',
            codes: ['1f602'],
            keywords: [
                'лол',
                'Слёзы',
                'Laughing',
                'Crying',
                'Tears',
                'LOL',
                `:'‑)`,
                `:')`,
                ':D',
                ':‑D',
                'X‑D',
                'XD',
                'Ха-ха',
            ],
        },
        {
            name: 'Rolling on The Floor Laughing',
            codes: ['1f923'],
            keywords: [
                'рофл',
                'Слеза',
                'Слёзы',
                'ROFL',
                'X‑D',
                'XD',
                `:'‑)`,
                `:')`,
                `:'‑D`,
                `:'D`,
                ':D',
                ':‑D',
                '=D',
                'Ха-ха',
            ],
        },
        {
            name: 'Grinning Face With Big Eyes',
            codes: ['1f603'],
            keywords: ['Улыбка', ':D', ':‑D', '=D', 'Ха-ха', 'Смех', 'Смешно'],
        },
        {
            name: 'Grinning Face With Smiling Eyes',
            codes: ['1f604'],
            keywords: ['Улыбка', ':D', ':‑D', 'X‑D', 'XD', 'Ха-ха', 'Смех', 'Смешно'],
        },
        {
            name: 'Grinning Face With Sweat',
            codes: ['1f605'],
            keywords: ['Улыбка', ':D', ':‑D', 'X‑D', 'XD', 'Ха-ха', 'Смех', 'Смешно'],
        },
        {
            name: 'Grinning Squinting Face',
            codes: ['1f606'],
            keywords: ['Улыбка', 'X‑D', 'XD', ':D', ':‑D', 'Ха-ха', 'Смех', 'Смешно'],
        },
        { name: 'Winking Face', codes: ['1f609'], keywords: [';)', ';-)', ';D', 'Ха-ха', 'Смех', 'Смешно'] },
        { name: 'Smiling Face With Smiling Eyes', codes: ['1f60a'], keywords: [ 'Ха-ха', 'Смех', 'Смешно'] },
        { name: 'Face Savoring Food', codes: ['1f60b'], keywords: ['Еда', 'Язык'] },
        {
            name: 'Smiling Face With Sunglasses',
            codes: ['1f60e'],
            keywords: ['Очки', 'Улыбка', '8)', '8-)', 'B)', 'B-)', '8|', 'B|', '8-|', 'B-|'],
        },
        {
            name: 'Smiling Face With Heart-eyes',
            codes: ['1f60d'],
            keywords: ['Любовь', 'Сердце', 'Сердечко', 'Сердечки', 'Kiss', ':-*', ':*', ':×'],
        },
        {
            name: 'Face Blowing a Kiss',
            codes: ['1f618'],
            keywords: ['Поцелуй', 'Kiss', ':-*', ':*', ':×'],
        },
        {
            name: 'Kissing Face',
            codes: ['1f617'],
            keywords: ['Поцелуй', 'Kiss', ':-*', ':*', ':×'],
        },
        {
            name: 'Kissing Face With Smiling Eyes',
            codes: ['1f619'],
            keywords: ['Поцелуй', 'Kiss', ':-*', ':*', ':×'],
        },
        {
            name: 'Kissing Face With Closed Eyes',
            codes: ['1f61a'],
            keywords: ['Поцелуй', 'Kiss', ':-*', ':*', ':×'],
        },
        { name: 'Slightly Smiling Face', codes: ['1f642'], keywords: ['Улыбка', ':)', ':-)'] },
        { name: 'Hugging Face', codes: ['1f917'], keywords: ['Обнимашки', 'Объятия'] },
        { name: 'Star-Struck', codes: ['1f929'], keywords: ['Смайл', 'Вау', 'Класс'] },
        {
            name: 'Thinking Face',
            codes: ['1f914'],
            keywords: ['Не знаю', 'Возможно', 'Наверное', 'Мысль', 'Мысли'],
        },
        { name: 'Face With Raised Eyebrow', codes: ['1f928'], keywords: ['Что', 'Сомнение'] },
        { name: 'Neutral Face', codes: ['1f610'], keywords: [':|', ':-|'] },
        { name: 'Expressionless Face', codes: ['1f611'], keywords: [':‑|', ':|'] },
        {
            name: 'Face Without Mouth',
            codes: ['1f636'],
            keywords: [':‑X', ':X', ':‑#', ':#', ':‑&', ':&'],
        },
        { name: 'Face With Rolling Eyes', codes: ['1f644'], keywords: ['Не знаю', 'Закатывать глаза'] },
        { name: 'Smirking Face', codes: ['1f60f'], keywords: ['Ухмылка', 'Доволен'] },
        { name: 'Persevering Face', codes: ['1f623'], keywords: ['Грусть', 'Боль', 'Печать', 'Смайл'] },
        { name: 'Sad But Relieved Face', codes: ['1f625'], keywords: ['Грусть'] },
        {
            name: 'Face With Open Mouth',
            codes: ['1f62e'],
            keywords: [':‑O', ':O', ':-0', '8‑0', '>:O'],
        },
        {
            name: 'Zipper-Mouth Face',
            codes: ['1f910'],
            keywords: ['Молчание', 'Молния', ':‑X', ':X', ':‑#', ':#', ':‑&', ':&'],
        },
        { name: 'Hushed Face', codes: ['1f62f'], keywords: [':‑O', ':O', ':-0', '8‑0', '>:O'] },
        {
            name: 'Sleepy Face',
            codes: ['1f62a'],
            keywords: ['Сон', 'Спящий', 'Спит', 'Сплю', 'zzz', 'z-z-z'],
        },
        {
            name: 'Tired Face',
            codes: ['1f62b'],
            keywords: ['Устал', 'Уставший', 'Усталось', 'Мучение', 'Огорчение'],
        },
        {
            name: 'Sleeping Face',
            codes: ['1f634'],
            keywords: ['Сон', 'Спящий', 'Спит', 'Сплю', 'zzz', 'z-z-z'],
        },
        { name: 'Relieved Face', codes: ['1f60c'], keywords: ['Облегчение', 'Умиротворение'] },
        { name: 'Face With Tongue', codes: ['1f61b'], keywords: ['Язык', ':-P', ':P', '=P'] },
        { name: 'Winking Face With Tongue', codes: ['1f61c'], keywords: ['Язык', ';p', ';-p'] },
        { name: 'Squinting Face With Tongue', codes: ['1f61d'], keywords: ['Язык'] },
        { name: 'Drooling Face', codes: ['1f924'], keywords: ['Слюна', 'Слюни'] },
        { name: 'Unamused Face', codes: ['1f612'], keywords: ['Недоволен', 'Сомнение', 'Сомневаюсь'] },
        { name: 'Downcast Face With Sweat', codes: ['1f613'], keywords: [''] },
        { name: 'Pensive Face', codes: ['1f614'], keywords: ['Расстройство', 'Расстроенный'] },
        { name: 'Confused Face', codes: ['1f615'], keywords: ['Расстройство', 'Расстроенный'] },
        { name: 'Upside-Down Face', codes: ['1f643'], keywords: ['Перевернутое лицо'] },
        { name: 'Money-Mouth Face', codes: ['1f911'], keywords: [] },
        { name: 'Astonished Face', codes: ['1f632'], keywords: [':‑O', ':O', ':-0', '8‑0', '>:O'] },
        { name: 'Slightly Frowning Face', codes: ['1f641'], keywords: [':(', ':-('] },
        { name: 'Confounded Face', codes: ['1f616'], keywords: [':$'] },
        {
            name: 'Disappointed Face',
            codes: ['1f61e'],
            keywords: ['Огорчение', 'Расстройство', 'Embarrassed', 'Blushing', ':(', ':-(', ':$'],
        },
        { name: 'Worried Face', codes: ['1f61f'], keywords: [] },
        { name: 'Face With Steam From Nose', codes: ['1f624'], keywords: ['Пар'] },
        {
            name: 'Crying Face',
            codes: ['1f622'],
            keywords: ['Слезы', 'Слёзы', 'Огорчение', 'Расстройство', `:'(`, `:'‑(`],
        },
        {
            name: 'Loudly Crying Face',
            codes: ['1f62d'],
            keywords: ['Слезы', 'Слёзы', 'Огорчение', 'Расстройство', `:'(`, `:'‑(`],
        },
        {
            name: 'Frowning Face With Open Mouth',
            codes: ['1f626'],
            keywords: ['Недоумение', 'Огорчение', 'Расстройство'],
        },
        {
            name: 'Anguished Face',
            codes: ['1f627'],
            keywords: ['Огорчение', 'Расстройство', 'Страдание', 'Мучение'],
        },
        { name: 'Fearful Face', codes: ['1f628'], keywords: ['Страх', 'Ужас', 'Испуг'] },
        { name: 'Weary Face', codes: ['1f629'], keywords: ['Тоска'] },
        {
            name: 'Exploding Head',
            codes: ['1f92f'],
            keywords: ['Шок', 'Потрясение', 'Ужас', 'shock', 'mind', 'blown', 'awe', '>:O'],
        },
        {
            name: 'Grimacing Face',
            codes: ['1f62c'],
            keywords: ['Зубы', 'Испуг', 'Страх', 'Ужас', 'teeth', 'eek!'],
        },
        { name: 'Anxious Face With Sweat', codes: ['1f630'], keywords: ['Страх'] },
        { name: 'Face Screaming in Fear', codes: ['1f631'], keywords: ['Страх', 'Ужас', 'Испуг'] },
        { name: 'Flushed Face', codes: ['1f633'], keywords: ['Embarrassed', 'Blushing', ':$'] },
        { name: 'Crazy Face', codes: ['1f92a'], keywords: ['Чокнутый', 'Сумасшедший'] },
        { name: 'Dizzy Face', codes: ['1f635'], keywords: [] },
        { name: 'Pouting Face', codes: ['1f621'], keywords: ['Обида', 'Злость'] },
        { name: 'Angry Face', codes: ['1f620'], keywords: ['Обида', 'Злость'] },
        {
            name: 'Face With Symbols on Mouth',
            codes: ['1f92c'],
            keywords: ['Обида', 'Злость', 'Ругань', 'Брань', 'Мат'],
        },
        {
            name: 'Face With Medical Mask',
            codes: ['1f637'],
            keywords: [
                'Повязка',
                'Болезнь',
                'Простуда',
                'Заболел',
                'Заболела',
                'Болеет',
                'Sick',
                ':‑###..',
                ':###..',
            ],
        },
        {
            name: 'Face With Thermometer',
            codes: ['1f912'],
            keywords: [
                'Градусник',
                'Болезнь',
                'Простуда',
                'Простыл',
                'Заболел',
                'Заболела',
                'Болеет',
                'Sick',
                ':‑###..',
                ':###..',
            ],
        },
        {
            name: 'Face With Head-Bandage',
            codes: ['1f915'],
            keywords: ['Заболел', 'Боль', 'Болит', 'Болеет', 'Ушиб', 'Sick', ':‑###..', ':###..'],
        },
        {
            name: 'Nauseated Face',
            codes: ['1f922'],
            keywords: ['Тошнота', 'Тошнит', 'Sick', ':‑###..', ':###..'],
        },
        {
            name: 'Face Vomiting',
            codes: ['1f92e'],
            keywords: ['Рвота', 'Тошнит', 'Sick', ':‑###..', ':###..'],
        },
        {
            name: 'Sneezing Face',
            codes: ['1f927'],
            keywords: [
                'Заболел',
                'Боль',
                'Болит',
                'Болеет',
                'Простуда',
                'Простыл',
                'Sick',
                ':‑###..',
                ':###..',
            ],
        },
        { name: 'Smiling Face With Halo', codes: ['1f607'], keywords: [] },
        { name: 'Cowboy Hat Face', codes: ['1f920'], keywords: [] },
        { name: 'Clown Face', codes: ['1f921'], keywords: [] },
        {
            name: 'Lying Face',
            codes: ['1f925'],
            keywords: ['Врун', 'Лжец', 'Враньё', 'Неправда', 'Обман'],
        },
        {
            name: 'Shushing Face',
            codes: ['1f92b'],
            keywords: ['Тишина', 'Тихо', 'Молчание', ' :‑X', ':X', ':‑#', ':#', ':‑&', ':&'],
        },
        {
            name: 'Face With Hand Over Mouth',
            codes: ['1f92d'],
            keywords: ['Тишина', 'Тихо', 'Молчание', ' :‑X', ':X', ':‑#', ':#', ':‑&', ':&'],
        },
        { name: 'Face With Monocle', codes: ['1f9d0'], keywords: ['Очки'] },
        {
            name: 'Nerd Face',
            codes: ['1f913'],
            keywords: ['Заучка', 'Ученый', 'Учёный', '8)', '8-)', 'B)', 'B-)'],
        },
        { name: 'Smiling Face With Horns', codes: ['1f608'], keywords: [] },
        { name: 'Angry Face With Horns', codes: ['1f47f'], keywords: ['Злой', 'Злость'] },
        {
            name: 'Ogre',
            codes: ['1f479'],
            keywords: ['Чудовище', 'Злой', 'Злость', 'Злоба', 'Монстр', 'Урод'],
        },
        { name: 'Goblin', codes: ['1f47a'], keywords: ['Урод', 'Чудовище', 'Монстр'] },
        { name: 'Ghost', codes: ['1f47b'], keywords: ['Привидение'] },
        { name: 'Alien', codes: ['1f47d'], keywords: ['Инопланетянин'] },
        { name: 'Alien Monster', codes: ['1f47e'], keywords: ['Инопланетянин'] },
        { name: 'Robot Face', codes: ['1f916'], keywords: ['Робот'] },
        { name: 'Pile of Poo', codes: ['1f4a9'], keywords: ['Какашка', 'Кал'] },
        { name: 'Grinning Cat Face', codes: ['1f63a'], keywords: ['Кот', 'Кошка'] },
        {
            name: 'Grinning Cat Face With Smiling Eyes',
            codes: ['1f638'],
            keywords: ['Кот', 'Кошка'],
        },
        {
            name: 'Cat Face With Tears of Joy',
            codes: ['1f639'],
            keywords: ['Слезы', 'Слёзы', 'Кот', 'Кошка'],
        },
        {
            name: 'Smiling Cat Face With Heart-Eyes',
            codes: ['1f63b'],
            keywords: ['Любовь', 'Кот', 'Кошка'],
        },
        { name: 'Cat Face With Wry Smile', codes: ['1f63c'], keywords: ['Кот', 'Кошка'] },
        {
            name: 'Kissing Cat Face',
            codes: ['1f63d'],
            keywords: ['Поцелуй', 'Кот', 'Кошка', ':-*', ':*', ':×'],
        },
        {
            name: 'Weary Cat Face',
            codes: ['1f640'],
            keywords: ['Кот', 'Кошка', 'Ужас', 'Страх', 'Кошмар'],
        },
        { name: 'Crying Cat Face', codes: ['1f63f'], keywords: ['Слёзы', 'Слеза', 'Кот', 'Кошка'] },
        { name: 'Pouting Cat Face', codes: ['1f63e'], keywords: [] },
        { name: 'See-No-Evil Monkey', codes: ['1f648'], keywords: ['Обезьяна'] },
        { name: 'Hear-No-Evil Monkey', codes: ['1f649'], keywords: ['Обезьяна'] },
        { name: 'Speak-No-Evil Monkey', codes: ['1f64a'], keywords: ['Обезьяна'] },
        { name: 'Baby', codes: ['1f476'], keywords: ['Человек', 'Ребенок', 'Ребёнок', 'Лицо'] },
        { name: 'Child', codes: ['1f9d2'], keywords: ['Человек', 'Ребёнок', 'Лицо'] },
        { name: 'Boy', codes: ['1f466'], keywords: ['Человек', 'Ребенок', 'Ребёнок', 'Лицо'] },
        { name: 'Girl', codes: ['1f467'], keywords: ['Человек', 'Ребенок', 'Ребёнок', 'Лицо'] },
        { name: 'Adult', codes: ['1f9d1'], keywords: ['Человек', 'Лицо'] },
        { name: 'Man', codes: ['1f468'], keywords: ['Человек', 'Лицо'] },
        { name: 'Woman', codes: ['1f469'], keywords: ['Человек', 'Лицо'] },
        { name: 'Older Adult', codes: ['1f9d3'], keywords: ['Человек', 'Лицо'] },
        { name: 'Old Man', codes: ['1f474'], keywords: ['Человек', 'Лицо'] },
        { name: 'Old Woman', codes: ['1f475'], keywords: ['Человек', 'Лицо'] },
        { name: 'Man Student', codes: ['1f468', '200d', '1f393'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Student', codes: ['1f469', '200d', '1f393'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Teacher', codes: ['1f468', '200d', '1f3eb'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Teacher', codes: ['1f469', '200d', '1f3eb'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Farmer', codes: ['1f468', '200d', '1f33e'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Farmer', codes: ['1f469', '200d', '1f33e'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Cook', codes: ['1f468', '200d', '1f373'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Cook', codes: ['1f469', '200d', '1f373'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Mechanic', codes: ['1f468', '200d', '1f527'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Mechanic', codes: ['1f469', '200d', '1f527'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Factory Worker', codes: ['1f468', '200d', '1f3ed'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Factory Worker', codes: ['1f469', '200d', '1f3ed'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Office Worker', codes: ['1f468', '200d', '1f4bc'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Office Worker', codes: ['1f469', '200d', '1f4bc'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Scientist', codes: ['1f468', '200d', '1f52c'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Scientist', codes: ['1f469', '200d', '1f52c'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Technologist', codes: ['1f468', '200d', '1f4bb'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Technologist', codes: ['1f469', '200d', '1f4bb'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Singer', codes: ['1f468', '200d', '1f3a4'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Singer', codes: ['1f469', '200d', '1f3a4'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Artist', codes: ['1f468', '200d', '1f3a8'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Artist', codes: ['1f469', '200d', '1f3a8'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Astronaut', codes: ['1f468', '200d', '1f680'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Astronaut', codes: ['1f469', '200d', '1f680'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Man Firefighter', codes: ['1f468', '200d', '1f692'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Woman Firefighter', codes: ['1f469', '200d', '1f692'], keywords: ['Человек', 'Лицо', 'Профессия'] },
        { name: 'Prince', codes: ['1f934'], keywords: ['Человек'] },
        { name: 'Princess', codes: ['1f478'], keywords: ['Человек'] },
        { name: 'Woman With Headscarf', codes: ['1f9d5'], keywords: ['Человек'] },
        { name: 'Bearded Person', codes: ['1f9d4'], keywords: ['Человек'] },
        { name: 'Man in Tuxedo', codes: ['1f935'], keywords: ['Человек'] },
        { name: 'Bride With Veil', codes: ['1f470'], keywords: ['Человек'] },
        { name: 'Pregnant Woman', codes: ['1f930'], keywords: ['Человек'] },
        { name: 'Breast-Feeding', codes: ['1f931'], keywords: ['Человек'] },
        { name: 'Baby Angel', codes: ['1f47c'], keywords: ['O:)', 'O:-)'] },
        { name: 'Santa Claus', codes: ['1f385'], keywords: ['Санта Клаус', 'Новый год', 'Праздник'] },
        { name: 'Mrs. Claus', codes: ['1f936'], keywords: ['Санта Клаус', 'Новый год', 'Праздник'] },
        { name: 'Woman Dancing', codes: ['1f483'], keywords: ['Человек', 'Танцы', 'Веселье'] },
        { name: 'Man Dancing', codes: ['1f57a'], keywords: ['Человек', 'Танцы', 'Веселье'] },
        { name: 'People With Bunny Ears', codes: ['1f46f'], keywords: ['Человек'] },
        { name: 'Person Taking Bath', codes: ['1f6c0'], keywords: ['Человек'] },
        { name: 'Person in Bed', codes: ['1f6cc'], keywords: ['Человек', 'Отдых', 'Сон'] },
        { name: 'Person Fencing', codes: ['1f93a'], keywords: ['Человек'] },
        { name: 'Horse Racing', codes: ['1f3c7'], keywords: ['Человек'] },
        { name: 'Snowboarder', codes: ['1f3c2'], keywords: ['Человек'] },
        { name: 'Racing Car', codes: ['1f3ce'], keywords: ['Человек'] },
        { name: 'Motorcycle', codes: ['1f3cd'], keywords: ['Человек'] },
        { name: 'Man And Woman Holding Hands', codes: ['1f46b'], keywords: ['Человек'] },
        { name: 'Two Men Holding Hands', codes: ['1f46c'], keywords: ['Человек'] },
        { name: 'Two Women Holding Hands', codes: ['1f46d'], keywords: ['Человек'] },
        {
            name: 'Family: Man, Woman, Boy',
            codes: ['1f468', '200d', '1f469', '200d', '1f466'],
            keywords: ['Человек', 'Семья', 'Люди'],
        },
        {
            name: 'Family: Man, Woman, Girl',
            codes: ['1f468', '200d', '1f469', '200d', '1f467'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Man, Woman, Girl, Boy',
            codes: ['1f468', '200d', '1f469', '200d', '1f467', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Man, Woman, Boy, Boy',
            codes: ['1f468', '200d', '1f469', '200d', '1f466', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Man, Woman, Girl, Girl',
            codes: ['1f468', '200d', '1f469', '200d', '1f467', '200d', '1f467'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Man, Man, Boy',
            codes: ['1f468', '200d', '1f468', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Man, Man, Girl',
            codes: ['1f468', '200d', '1f468', '200d', '1f467'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Man, Man, Girl, Boy',
            codes: ['1f468', '200d', '1f468', '200d', '1f467', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Man, Man, Boy, Boy',
            codes: ['1f468', '200d', '1f468', '200d', '1f466', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Man, Man, Girl, Girl',
            codes: ['1f468', '200d', '1f468', '200d', '1f467', '200d', '1f467'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Woman, Woman, Boy',
            codes: ['1f469', '200d', '1f469', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Woman, Woman, Girl',
            codes: ['1f469', '200d', '1f469', '200d', '1f467'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Woman, Woman, Girl, Boy',
            codes: ['1f469', '200d', '1f469', '200d', '1f467', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Woman, Woman, Boy, Boy',
            codes: ['1f469', '200d', '1f469', '200d', '1f466', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Woman, Woman, Girl, Girl',
            codes: ['1f469', '200d', '1f469', '200d', '1f467', '200d', '1f467'],
            keywords: ['Семья', 'Люди'],
        },
        { name: 'Family: Man, Boy', codes: ['1f468', '200d', '1f466'], keywords: ['Семья', 'Люди'] },
        {
            name: 'Family: Man, Boy, Boy',
            codes: ['1f468', '200d', '1f466', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        { name: 'Family: Man, Girl', codes: ['1f468', '200d', '1f467'], keywords: ['Семья', 'Люди'] },
        {
            name: 'Family: Man, Girl, Boy',
            codes: ['1f468', '200d', '1f467', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Man, Girl, Girl',
            codes: ['1f468', '200d', '1f467', '200d', '1f467'],
            keywords: ['Семья', 'Люди'],
        },
        { name: 'Family: Woman, Boy', codes: ['1f469', '200d', '1f466'], keywords: ['Семья', 'Люди'] },
        {
            name: 'Family: Woman, Boy, Boy',
            codes: ['1f469', '200d', '1f466', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        { name: 'Family: Woman, Girl', codes: ['1f469', '200d', '1f467'], keywords: ['Семья', 'Люди'] },
        {
            name: 'Family: Woman, Girl, Boy',
            codes: ['1f469', '200d', '1f467', '200d', '1f466'],
            keywords: ['Семья', 'Люди'],
        },
        {
            name: 'Family: Woman, Girl, Girl',
            codes: ['1f469', '200d', '1f467', '200d', '1f467'],
            keywords: ['Семья', 'Люди'],
        },
        { name: 'Selfie', codes: ['1f933'], keywords: ['Рука', 'Селфи'] },
        { name: 'Flexed Biceps', codes: ['1f4aa'], keywords: ['Рука', 'Спорт', 'Сила', 'Бицепс'] },
        { name: 'Backhand Index Pointing Left', codes: ['1f448'], keywords: ['Рука', 'Влево', 'Жест'] },
        { name: 'Backhand Index Pointing Right', codes: ['1f449'], keywords: ['Рука', 'Вправо', 'Жест'] },
        { name: 'Index Pointing Up', codes: ['261d'], keywords: ['Рука', 'Жест', 'Вверх', 'Палец'] },
        { name: 'Backhand Index Pointing Up', codes: ['1f446'], keywords: ['Рука', 'Жест', 'Вверх'] },
        { name: 'Middle Finger', codes: ['1f595'], keywords: ['Рука', 'Жест', 'Средний палец'] },
        { name: 'Backhand Index Pointing Down', codes: ['1f447'], keywords: ['Рука', 'Жест', 'Вниз'] },
        { name: 'Victory Hand', codes: ['270c'], keywords: ['Рука', 'Жест', 'Победа'] },
        { name: 'Crossed Fingers', codes: ['1f91e'], keywords: ['Рука', 'Жест', 'Скрестить', 'Скрещенные пальцы'] },
        { name: 'Vulcan Salute', codes: ['1f596'], keywords: ['Рука', 'Жест', 'Салют', 'Ура'] },
        { name: 'Sign of The Horns', codes: ['1f918'], keywords: ['Рука', 'Жест', 'Зов', 'Звать'] },
        { name: 'Call Me Hand', codes: ['1f919'], keywords: ['Рука', 'Жест', 'Звонок', 'Позвонить'] },
        { name: 'Hand With Fingers Splayed', codes: ['1f590'], keywords: ['Рука', 'Жест'] },
        { name: 'Raised Hand', codes: ['270b'], keywords: ['Рука', 'Жест'] },
        { name: 'OK Hand', codes: ['1f44c'], keywords: ['Рука', 'Жест', 'ОК'] },
        { name: 'Thumbs Up', codes: ['1f44d'], keywords: ['Рука', 'Жест'] },
        { name: 'Thumbs Down', codes: ['1f44e'], keywords: ['Рука', 'Жест'] },
        { name: 'Raised Fist', codes: ['270a'], keywords: ['Рука', 'Жест', 'Кулак'] },
        { name: 'Oncoming Fist', codes: ['1f44a'], keywords: ['Рука', 'Жест', 'Кулак'] },
        { name: 'Left-Facing Fist', codes: ['1f91b'], keywords: ['Рука', 'Жест', 'Кулак'] },
        { name: 'Right-Facing Fist', codes: ['1f91c'], keywords: ['Рука', 'Жест', 'Кулак'] },
        { name: 'Raised Back of Hand', codes: ['1f91a'], keywords: ['Рука', 'Жест'] },
        { name: 'Waving Hand', codes: ['1f44b'], keywords: ['Рука', 'Жест'] },
        { name: 'Love-You Gesture', codes: ['1f91f'], keywords: ['Любовь'] },
        { name: 'Writing Hand', codes: ['270d'], keywords: ['Рука', 'Ладони'] },
        { name: 'Clapping Hands', codes: ['1f44f'], keywords: ['Рука', 'Ладони'] },
        { name: 'Open Hands', codes: ['1f450'], keywords: ['Рука', 'Ладони'] },
        { name: 'Raising Hands', codes: ['1f64c'], keywords: ['Рука', 'Ладони'] },
        { name: 'Palms Up Together', codes: ['1f932'], keywords: ['Рука', 'Ладони', 'Вместе'] },
        { name: 'Folded Hands', codes: ['1f64f'], keywords: ['Рука', 'Ладони'] },
        { name: 'Handshake', codes: ['1f91d'], keywords: ['Рука', 'Ладони', 'Рукопожатие'] },
        { name: 'Nail Polish', codes: ['1f485'], keywords: ['Рука', 'Ноготь', 'Лак'] },
        { name: 'Ear', codes: ['1f442'], keywords: ['Человек', 'Ухо'] },
        { name: 'Nose', codes: ['1f443'], keywords: ['Человек', 'Нос'] },
        { name: 'Footprints', codes: ['1f463'], keywords: ['Человек', 'Ступни'] },
        { name: 'Eyes', codes: ['1f440'], keywords: ['Человек', 'Глаз', 'Глаза'] },
        { name: 'Eye', codes: ['1f441'], keywords: ['Человек', 'Глаз', 'Глаза'] },
        { name: 'Brain', codes: ['1f9e0'], keywords: ['Человек', 'Мозг'] },
        { name: 'Tongue', codes: ['1f445'], keywords: ['Человек', 'Язык'] },
        { name: 'Mouth', codes: ['1f444'], keywords: ['Поцелуй', 'Рот'] },
        { name: 'Kiss Mark', codes: ['1f48b'], keywords: ['Поцелуй', 'Любовь'] },
        { name: 'Heart With Arrow', codes: ['1f498'], keywords: ['Любовь'] },
        { name: 'Red Heart', codes: ['2764'], keywords: ['Любовь'] },
        { name: 'Beating Heart', codes: ['1f493'], keywords: ['Любовь'] },
        { name: 'Broken Heart', codes: ['1f494'], keywords: [] },
        { name: 'Two Hearts', codes: ['1f495'], keywords: ['Любовь'] },
        { name: 'Sparkling Heart', codes: ['1f496'], keywords: ['Блёстки', 'Сердце', 'Любовь'] },
        { name: 'Growing Heart', codes: ['1f497'], keywords: ['Сердце'] },
        { name: 'Zzz', codes: ['1f4a4'], keywords: ['Сон'] },
        { name: 'Bomb', codes: ['1f4a3'], keywords: ['Взрыв'] },
        { name: 'Collision', codes: ['1f4a5'], keywords: ['Взрыв'] },
        { name: 'Sweat Droplets', codes: ['1f4a6'], keywords: [] },
        { name: 'Dashing Away', codes: ['1f4a8'], keywords: ['Ветер'] },
        { name: 'Speech Balloon', codes: ['1f4ac'], keywords: [] },
        { name: 'Thought Balloon', codes: ['1f4ad'], keywords: [] },
        { name: 'Hole', codes: ['1f573'], keywords: ['Дыра'] },
        { name: 'Glasses', codes: ['1f453'], keywords: ['Очки'] },
        { name: 'Sunglasses', codes: ['1f576'], keywords: ['Очки', 'Солнце', 'Лето', 'Море'] },
        { name: 'Necktie', codes: ['1f454'], keywords: ['Одежда'] },
        { name: 'T-Shirt', codes: ['1f455'], keywords: ['Одежда'] },
        { name: 'Jeans', codes: ['1f456'], keywords: ['Одежда'] },
        { name: 'Scarf', codes: ['1f9e3'], keywords: ['Одежда'] },
        { name: 'Gloves', codes: ['1f9e4'], keywords: ['Одежда'] },
        { name: 'Coat', codes: ['1f9e5'], keywords: ['Одежда'] },
        { name: 'Socks', codes: ['1f9e6'], keywords: ['Одежда'] },
        { name: 'Dress', codes: ['1f457'], keywords: ['Одежда'] },
        { name: 'Kimono', codes: ['1f458'], keywords: ['Одежда'] },
        { name: 'Bikini', codes: ['1f459'], keywords: ['Одежда'] },
        { name: 'Woman’s Clothes', codes: ['1f45a'], keywords: ['Одежда'] },
        { name: 'Purse', codes: ['1f45b'], keywords: ['Сумка'] },
        { name: 'Handbag', codes: ['1f45c'], keywords: ['Сумка', 'Сумочка'] },
        { name: 'Clutch Bag', codes: ['1f45d'], keywords: ['Сумка'] },
        { name: 'Shopping Bags', codes: ['1f6cd'], keywords: ['Сумка'] },
        { name: 'School Backpack', codes: ['1f392'], keywords: ['Сумка', 'Рюкзак'] },
        { name: 'Man’s Shoe', codes: ['1f45e'], keywords: ['Обувь'] },
        { name: 'Running Shoe', codes: ['1f45f'], keywords: ['Обувь'] },
        { name: 'High-Heeled Shoe', codes: ['1f460'], keywords: ['Обувь'] },
        { name: 'Woman’s Sandal', codes: ['1f461'], keywords: ['Обувь'] },
        { name: 'Woman’s Boot', codes: ['1f462'], keywords: ['Обувь'] },
        { name: 'Crown', codes: ['1f451'], keywords: ['Корона', 'Головной убор'] },
        { name: 'Woman’s Hat', codes: ['1f452'], keywords: ['Шляпа'] },
        { name: 'Top Hat', codes: ['1f3a9'], keywords: ['Шляпа'] },
        { name: 'Graduation Cap', codes: ['1f393'], keywords: ['Кепка', 'Бейсболка'] },
        { name: 'Billed Cap', codes: ['1f9e2'], keywords: ['Бейсболка', 'Кепка'] },
        { name: 'Rescue Worker’s Helmet', codes: ['26d1'], keywords: [] },
        { name: 'Prayer Beads', codes: ['1f4ff'], keywords: ['Чётки'] },
        { name: 'Lipstick', codes: ['1f484'], keywords: ['Помада', 'Красота'] },
        { name: 'Ring', codes: ['1f48d'], keywords: ['Кольцо'] },
        { name: 'Gem Stone', codes: ['1f48e'], keywords: ['Камень'] },
    ],

    [EMOJI_CATEGORIES.ANIMALS_AND_NATURE]: [
        { name: 'Monkey Face', codes: ['1f435'], keywords: ['Животное', 'Обезьяна'] },
        { name: 'Monkey', codes: ['1f412'], keywords: ['Животное', 'Обезьяна'] },
        { name: 'Gorilla', codes: ['1f98d'], keywords: ['Животное', 'Обезьяна'] },
        { name: 'Dog Face', codes: ['1f436'], keywords: ['Животное', 'Собака', 'Пес', 'Пёс'] },
        { name: 'Dog', codes: ['1f415'], keywords: ['Животное', 'Собака', 'Пес', 'Пёс'] },
        { name: 'Poodle', codes: ['1f429'], keywords: ['Животное', 'Собака', 'Пудель'] },
        { name: 'Wolf Face', codes: ['1f43a'], keywords: ['Животное', 'Волк'] },
        { name: 'Fox Face', codes: ['1f98a'], keywords: ['Животное', 'Лиса'] },
        { name: 'Cat Face', codes: ['1f431'], keywords: ['Животное', 'Кот', 'Кошка'] },
        { name: 'Cat', codes: ['1f408'], keywords: ['Животное', 'Кот', 'Кошка'] },
        { name: 'Lion Face', codes: ['1f981'], keywords: ['Животное', 'Лев'] },
        { name: 'Tiger Face', codes: ['1f42f'], keywords: ['Животное', 'Тигр'] },
        { name: 'Tiger', codes: ['1f405'], keywords: ['Животное', 'Тигр'] },
        { name: 'Leopard', codes: ['1f406'], keywords: ['Животное', 'Леопард', 'Кошка'] },
        { name: 'Horse Face', codes: ['1f434'], keywords: ['Лошадь', 'Животное'] },
        { name: 'Horse', codes: ['1f40e'], keywords: ['Животное', 'Лошадь'] },
        { name: 'Unicorn Face', codes: ['1f984'], keywords: ['Животное', 'Единорог'] },
        { name: 'Zebra', codes: ['1f993'], keywords: ['Животное', 'Зебра'] },
        { name: 'Deer', codes: ['1f98c'], keywords: ['Животное', 'Корова'] },
        { name: 'Cow Face', codes: ['1f42e'], keywords: ['Животное', 'Корова'] },
        { name: 'Ox', codes: ['1f402'], keywords: ['Животное', 'Корова'] },
        { name: 'Water Buffalo', codes: ['1f403'], keywords: ['Животное', 'Корова'] },
        { name: 'Cow', codes: ['1f404'], keywords: ['Животное', 'Корова'] },
        { name: 'Pig Face', codes: ['1f437'], keywords: ['Животное', 'Свинья', 'Поросенок', 'Поросёнок'] },
        { name: 'Pig', codes: ['1f416'], keywords: ['Животное', 'Свинья', 'Поросенок', 'Поросёнок'] },
        { name: 'Boar', codes: ['1f417'], keywords: ['Животное', 'Кабан'] },
        { name: 'Pig Nose', codes: ['1f43d'], keywords: ['Животное', 'Свинья', 'Поросенок', 'Поросёнок'] },
        { name: 'Ram', codes: ['1f40f'], keywords: ['Животное', 'Баран'] },
        { name: 'Ewe', codes: ['1f411'], keywords: ['Животное', 'Овца'] },
        { name: 'Goat', codes: ['1f410'], keywords: ['Животное', 'Козёл'] },
        { name: 'Camel', codes: ['1f42a'], keywords: ['Животное', 'Верблюд'] },
        { name: 'Two-Hump Camel', codes: ['1f42b'], keywords: ['Животное', 'Верблюд'] },
        { name: 'Giraffe', codes: ['1f992'], keywords: ['Животное', 'Жираф'] },
        { name: 'Elephant', codes: ['1f418'], keywords: ['Животное', 'Слон'] },
        { name: 'Rhinoceros', codes: ['1f98f'], keywords: ['Животное', 'Носорог'] },
        { name: 'Mouse Face', codes: ['1f42d'], keywords: ['Животное', 'Мышь'] },
        { name: 'Mouse', codes: ['1f401'], keywords: ['Животное', 'Мышь'] },
        { name: 'Rat', codes: ['1f400'], keywords: ['Животное', 'Крыса'] },
        { name: 'Hamster Face', codes: ['1f439'], keywords: ['Животное', 'Хомяк'] },
        { name: 'Rabbit Face', codes: ['1f430'], keywords: ['Животное', 'Кролик'] },
        { name: 'Rabbit', codes: ['1f407'], keywords: ['Животное', 'Кролик'] },
        { name: 'Chipmunk', codes: ['1f43f'], keywords: ['Животное', 'Бурундук'] },
        { name: 'Hedgehog', codes: ['1f994'], keywords: ['Животное', 'Еж'] },
        { name: 'Bat', codes: ['1f987'], keywords: ['Животное', 'Летучая мышь'] },
        { name: 'Bear Face', codes: ['1f43b'], keywords: ['Животное', 'Медведь'] },
        { name: 'Koala', codes: ['1f428'], keywords: ['Животное', 'Коала'] },
        { name: 'Panda Face', codes: ['1f43c'], keywords: ['Животное', 'Панда'] },
        { name: 'Paw Prints', codes: ['1f43e'], keywords: ['Животное', 'Лапа'] },
        { name: 'Turkey', codes: ['1f983'], keywords: ['Птица'] },
        { name: 'Chicken', codes: ['1f414'], keywords: ['Птица'] },
        { name: 'Rooster', codes: ['1f413'], keywords: ['Курица', 'Птица'] },
        { name: 'Hatching Chick', codes: ['1f423'], keywords: ['Курица', 'Цыплёнок', 'Птица'] },
        { name: 'Baby Chick', codes: ['1f424'], keywords: ['Курица', 'Цыплёнок', 'Птица'] },
        {
            name: 'Front-Facing Baby Chick',
            codes: ['1f425'],
            keywords: ['Курица', 'Цыплёнок', 'Птица'],
        },
        { name: 'Bird', codes: ['1f426'], keywords: ['Птица'] },
        { name: 'Penguin', codes: ['1f427'], keywords: ['Животное', 'Пингвин'] },
        { name: 'Dove', codes: ['1f54a'], keywords: ['Птица'] },
        { name: 'Eagle', codes: ['1f985'], keywords: [] },
        { name: 'Duck', codes: ['1f986'], keywords: ['Птица'] },
        { name: 'Owl', codes: ['1f989'], keywords: ['Птица'] },
        { name: 'Frog Face', codes: ['1f438'], keywords: ['Животное', 'Лягушка'] },
        { name: 'Crocodile', codes: ['1f40a'], keywords: ['Животное', 'Крокодил'] },
        { name: 'Turtle', codes: ['1f422'], keywords: ['Животное', 'Черепаха'] },
        { name: 'Lizard', codes: ['1f98e'], keywords: ['Животное', ] },
        { name: 'Snake', codes: ['1f40d'], keywords: ['Животное', 'Змея'] },
        { name: 'Dragon Face', codes: ['1f432'], keywords: ['Дракон'] },
        { name: 'Dragon', codes: ['1f409'], keywords: ['Дракон'] },
        { name: 'Sauropod', codes: ['1f995'], keywords: ['Динозавр'] },
        { name: 'T-Rex', codes: ['1f996'], keywords: ['Динозавр'] },
        { name: 'Spouting Whale', codes: ['1f433'], keywords: ['Кит', 'Море'] },
        { name: 'Whale', codes: ['1f40b'], keywords: ['Кит'] },
        { name: 'Dolphin', codes: ['1f42c'], keywords: ['Дельфин', 'Море'] },
        { name: 'Fish', codes: ['1f41f'], keywords: ['Рыба', 'Море'] },
        { name: 'Tropical Fish', codes: ['1f420'], keywords: ['Рыба', 'Море', 'Тропики'] },
        { name: 'Blowfish', codes: ['1f421'], keywords: ['Рыба', 'Море'] },
        { name: 'Shark', codes: ['1f988'], keywords: ['Акула'] },
        { name: 'Octopus', codes: ['1f419'], keywords: ['Море', 'Осьминог'] },
        { name: 'Spiral Shell', codes: ['1f41a'], keywords: [] },
        { name: 'Crab', codes: ['1f980'], keywords: ['Море', 'Краб'] },
        { name: 'Shrimp', codes: ['1f990'], keywords: ['Море', 'кальмар'] },
        { name: 'Squid', codes: ['1f991'], keywords: ['Море', 'Улитка'] },
        { name: 'Snail', codes: ['1f40c'], keywords: ['Рыба', 'Улитка'] },
        { name: 'Butterfly', codes: ['1f98b'], keywords: ['Насекомое'] },
        { name: 'Bug', codes: ['1f41b'], keywords: ['Насекомое'] },
        { name: 'Ant', codes: ['1f41c'], keywords: ['Насекомое'] },
        { name: 'Honeybee', codes: ['1f41d'], keywords: ['Насекомое'] },
        { name: 'Lady Beetle', codes: ['1f41e'], keywords: ['Насекомое'] },
        { name: 'Cricket', codes: ['1f997'], keywords: ['Насекомое'] },
        { name: 'Spider', codes: ['1f577'], keywords: ['Насекомое'] },
        { name: 'Spider Web', codes: ['1f578'], keywords: ['Насекомое'] },
        { name: 'Scorpion', codes: ['1f982'], keywords: ['Насекомое'] },
        {
            name: 'Bouquet',
            codes: ['1f490'],
            keywords: ['Цветы', 'Цветок', '@};-', '@}->--', `@}‑;‑'‑‑-`, `@>‑‑>‑‑`],
        },
        {
            name: 'Rose',
            codes: ['1f339'],
            keywords: ['Цветы', 'Цветок', '@};-', '@}->--', `@}‑;‑'‑‑-`, `@>‑‑>‑‑`],
        },
        { name: 'Wilted Flower', codes: ['1f940'], keywords: ['Цветы', 'Цветок'] },
        { name: 'Sunflower', codes: ['1f33b'], keywords: ['Цветы', 'Цветок'] },
        { name: 'Blossom', codes: ['1f33c'], keywords: ['Цветы', 'Цветок'] },
        { name: 'Tulip', codes: ['1f337'], keywords: ['Цветы', 'Цветок'] },
        { name: 'Seedling', codes: ['1f331'], keywords: ['Растение'] },
        { name: 'Evergreen Tree', codes: ['1f332'], keywords: ['Растение'] },
        { name: 'Deciduous Tree', codes: ['1f333'], keywords: ['Растение'] },
        { name: 'Palm Tree', codes: ['1f334'], keywords: ['Растение'] },
        { name: 'Cactus', codes: ['1f335'], keywords: ['Растение'] },
        { name: 'Herb', codes: ['1f33f'], keywords: ['Растение'] },
        { name: 'Four Leaf Clover', codes: ['1f340'], keywords: ['Растение'] },
        { name: 'Maple Leaf', codes: ['1f341'], keywords: ['Осень'] },
        { name: 'Fallen Leaf', codes: ['1f342'], keywords: ['Осень'] },
        { name: 'Leaf Fluttering in Wind', codes: ['1f343'], keywords: ['Ветер', 'Осень'] },
    ],

    [EMOJI_CATEGORIES.FOOD_AND_DRINK]: [
        { name: 'Grapes', codes: ['1f347'], keywords: ['Фрукт', 'Вино'] },
        { name: 'Melon', codes: ['1f348'], keywords: [] },
        { name: 'Watermelon', codes: ['1f349'], keywords: [] },
        { name: 'Tangerine', codes: ['1f34a'], keywords: ['Фрукт'] },
        { name: 'Lemon', codes: ['1f34b'], keywords: ['Фрукт'] },
        { name: 'Banana', codes: ['1f34c'], keywords: ['Фрукт'] },
        { name: 'Pineapple', codes: ['1f34d'], keywords: ['Фрукт'] },
        { name: 'Red Apple', codes: ['1f34e'], keywords: ['Фрукт'] },
        { name: 'Green Apple', codes: ['1f34f'], keywords: ['Фрукт'] },
        { name: 'Pear', codes: ['1f350'], keywords: ['Фрукт'] },
        { name: 'Peach', codes: ['1f351'], keywords: ['Фрукт'] },
        { name: 'Cherries', codes: ['1f352'], keywords: ['Ягода'] },
        { name: 'Strawberry', codes: ['1f353'], keywords: ['Ягода'] },
        { name: 'Kiwi Fruit', codes: ['1f95d'], keywords: ['Фрукт'] },
        { name: 'Tomato', codes: ['1f345'], keywords: ['Овощ'] },
        { name: 'Coconut', codes: ['1f965'], keywords: ['Орех'] },
        { name: 'Avocado', codes: ['1f951'], keywords: ['Фрукт'] },
        { name: 'Eggplant', codes: ['1f346'], keywords: ['Овощ'] },
        { name: 'Potato', codes: ['1f954'], keywords: ['Овощ'] },
        { name: 'Carrot', codes: ['1f955'], keywords: ['Овощ'] },
        { name: 'Ear of Corn', codes: ['1f33d'], keywords: [] },
        { name: 'Hot Pepper', codes: ['1f336'], keywords: ['Овощ'] },
        { name: 'Cucumber', codes: ['1f952'], keywords: ['Овощ'] },
        { name: 'Broccoli', codes: ['1f966'], keywords: ['Овощ'] },
        { name: 'Mushroom', codes: ['1f344'], keywords: [] },
        { name: 'Peanuts', codes: ['1f95c'], keywords: ['Орех'] },
        { name: 'Chestnut', codes: ['1f330'], keywords: ['Орех'] },
        { name: 'Bread', codes: ['1f35e'], keywords: [] },
        { name: 'Croissant', codes: ['1f950'], keywords: ['Хлеб', 'Завтрак'] },
        { name: 'Baguette Bread', codes: ['1f956'], keywords: ['Хлеб'] },
        { name: 'Pancakes', codes: ['1f95e'], keywords: [] },
        { name: 'Cheese Wedge', codes: ['1f9c0'], keywords: ['Закуска', 'Вино'] },
        { name: 'Meat on Bone', codes: ['1f356'], keywords: ['Еда', 'Мясо'] },
        { name: 'Poultry Leg', codes: ['1f357'], keywords: ['Еда', 'Мясо'] },
        { name: 'Bacon', codes: ['1f953'], keywords: ['Мясо', 'Завтрак'] },
        { name: 'Hamburger', codes: ['1f354'], keywords: ['Мясо', 'Обед'] },
        { name: 'French Fries', codes: ['1f35f'], keywords: ['Еда', 'Закуска', 'Обед'] },
        { name: 'Pizza', codes: ['1f355'], keywords: ['Еда', 'Обед'] },
        { name: 'Hot Dog', codes: ['1f32d'], keywords: ['Еда', 'Обед'] },
        { name: 'Sandwich', codes: ['1f96a'], keywords: ['Еда', 'Закуска', 'Завтрак', 'Обед'] },
        { name: 'Taco', codes: ['1f32e'], keywords: ['Еда'] },
        { name: 'Burrito', codes: ['1f32f'], keywords: ['Шаурма', 'Шаверма', 'Кебаб', 'Еда'] },
        { name: 'Stuffed Flatbread', codes: ['1f959'], keywords: ['Еда'] },
        { name: 'Egg', codes: ['1f95a'], keywords: ['Еда', 'Завтрак'] },
        { name: 'Cooking', codes: ['1f373'], keywords: ['Еда', 'Завтрак'] },
        { name: 'Shallow Pan of Food', codes: ['1f958'], keywords: ['Еда', 'Обед', 'Ужин'] },
        { name: 'Pot of Food', codes: ['1f372'], keywords: ['Еда', 'Обед', 'Ужин'] },
        { name: 'Bowl With Spoon', codes: ['1f963'], keywords: ['Еда', 'Завтрак'] },
        { name: 'Green Salad', codes: ['1f957'], keywords: ['Еда', 'Обед', 'Ужин'] },
        { name: 'Popcorn', codes: ['1f37f'], keywords: ['Еда'] },
        { name: 'Canned Food', codes: ['1f96b'], keywords: ['Еда'] },
        { name: 'Bento Box', codes: ['1f371'], keywords: ['Еда', 'Обед', 'Япония'] },
        { name: 'Cooked Rice', codes: ['1f35a'], keywords: ['Еда'] },
        { name: 'Curry Rice', codes: ['1f35b'], keywords: ['Еда', 'Обед', 'Ужин'] },
        { name: 'Steaming Bowl', codes: ['1f35c'], keywords: ['Еда', 'Обед', 'Ужин'] },
        { name: 'Spaghetti', codes: ['1f35d'], keywords: ['Еда', 'Обед', 'Ужин'] },
        { name: 'Oden', codes: ['1f362'], keywords: ['Закуска'] },
        { name: 'Sushi', codes: ['1f363'], keywords: ['Закуска', 'Япония'] },
        { name: 'Fried Shrimp', codes: ['1f364'], keywords: ['Закуска'] },
        { name: 'Fortune Cookie', codes: ['1f960'], keywords: [] },
        { name: 'Takeout Box', codes: ['1f961'], keywords: ['Вок', 'Ужин', 'Обед'] },
        { name: 'Soft Ice Cream', codes: ['1f366'], keywords: ['Десерт', 'Сладость'] },
        { name: 'Ice Cream', codes: ['1f368'], keywords: ['Десерт', 'Сладость'] },
        { name: 'Doughnut', codes: ['1f369'], keywords: ['Десерт', 'Сладость'] },
        { name: 'Cookie', codes: ['1f36a'], keywords: ['Десерт', 'Сладость'] },
        { name: 'Birthday Cake', codes: ['1f382'], keywords: ['Десерт', 'Сладость'] },
        { name: 'Shortcake', codes: ['1f370'], keywords: ['Десерт', 'Сладость'] },
        { name: 'Pie', codes: ['1f967'], keywords: ['Десерт', 'Сладость'] },
        { name: 'Chocolate Bar', codes: ['1f36b'], keywords: ['Сладость'] },
        { name: 'Candy', codes: ['1f36c'], keywords: ['Сладость'] },
        { name: 'Lollipop', codes: ['1f36d'], keywords: ['Сладость'] },
        { name: 'Custard', codes: ['1f36e'], keywords: ['Десерт', 'Сладость'] },
        { name: 'Honey Pot', codes: ['1f36f'], keywords: ['Сладость'] },
        { name: 'Baby Bottle', codes: ['1f37c'], keywords: ['Напиток'] },
        { name: 'Glass of Milk', codes: ['1f95b'], keywords: ['Напиток'] },
        { name: 'Teacup Without Handle', codes: ['1f375'], keywords: ['Напиток'] },
        { name: 'Sake', codes: ['1f376'], keywords: ['Алкоголь', 'Япония'] },
        {
            name: 'Bottle With Popping Cork',
            codes: ['1f37e'],
            keywords: ['Шампанское', 'Игристое вино', 'Алкоголь'],
        },
        { name: 'Wine Glass', codes: ['1f377'], keywords: ['Вино', 'Алкоголь'] },
        { name: 'Cocktail Glass', codes: ['1f378'], keywords: ['Коктейль', 'Алкоголь'] },
        { name: 'Tropical Drink', codes: ['1f379'], keywords: ['Коктейль', 'Алкоголь'] },
        { name: 'Beer Mug', codes: ['1f37a'], keywords: ['Пиво', 'Алкоголь'] },
        { name: 'Clinking Beer Mugs', codes: ['1f37b'], keywords: ['Пиво', 'Алкоголь'] },
        {
            name: 'Clinking Glasses',
            codes: ['1f942'],
            keywords: ['Шампанское', 'Игристое вино', 'Алкоголь', 'Праздник'],
        },
        { name: 'Tumbler Glass', codes: ['1f943'], keywords: ['Алкоголь'] },
        { name: 'Cup With Straw', codes: ['1f964'], keywords: ['Напиток'] },
        { name: 'Chopsticks', codes: ['1f962'], keywords: ['Еда', 'Обед', 'Ужин', 'Завтрак'] },
        {
            name: 'Fork And Knife With Plate',
            codes: ['1f37d'],
            keywords: ['Еда', 'Обед', 'Ужин', 'Завтрак'],
        },
        { name: 'Fork And Knife', codes: ['1f374'], keywords: ['Еда', 'Обед', 'Ужин', 'Завтрак'] },
        { name: 'Spoon', codes: ['1f944'], keywords: ['Еда'] },
        { name: 'Kitchen Knife', codes: ['1f52a'], keywords: ['Еда'] },
    ],

    [EMOJI_CATEGORIES.TRAVEL_AND_PLACES]: [
        { name: 'Snow-Capped Mountain', codes: ['1f3d4'], keywords: ['Горы', 'Гора', 'Отпуск'] },
        { name: 'Mountain', codes: ['26f0'], keywords: ['Горы'] },
        { name: 'Volcano', codes: ['1f30b'], keywords: ['Горы', 'Гора'] },
        { name: 'Beach With Umbrella', codes: ['1f3d6'], keywords: ['Отпуск'] },
        { name: 'Desert Island', codes: ['1f3dd'], keywords: ['Отпуск'] },
        { name: 'Stadium', codes: ['1f3df'], keywords: ['Стадион'] },
        { name: 'House', codes: ['1f3e0'], keywords: ['Дом'] },
        { name: 'House With Garden', codes: ['1f3e1'], keywords: ['Дом', 'Сад', 'Дом с садом'] },
        { name: 'Office Building', codes: ['1f3e2'], keywords: ['Здание', 'Офис'] },
        { name: 'Hospital', codes: ['1f3e5'], keywords: ['Госпиталь'] },
        { name: 'Bank', codes: ['1f3e6'], keywords: ['Банк', 'Здание'] },
        { name: 'Hotel', codes: ['1f3e8'], keywords: ['Отель', 'Гостиница'] },
        { name: 'School', codes: ['1f3eb'], keywords: ['Школа', 'Здание'] },
        { name: 'Church', codes: ['26ea'], keywords: ['Бог', 'Церковь'] },
        { name: 'Mosque', codes: ['1f54c'], keywords: ['Бог', 'Мечеть'] },
        { name: 'Synagogue', codes: ['1f54d'], keywords: ['Бог', 'Синагога'] },
        { name: 'Shinto Shrine', codes: ['26e9'], keywords: ['Бог', 'Храм'] },
        { name: 'Kaaba', codes: ['1f54b'], keywords: ['Бог', 'Церковь'] },
        { name: 'Framed Picture', codes: ['1f5bc'], keywords: ['Картинка'] },
        { name: 'Artist Palette', codes: ['1f3a8'], keywords: ['Палитра', 'Художник'] },
        { name: 'Slot Machine', codes: ['1f3b0'], keywords: ['Развлечение'] },
        { name: 'Locomotive', codes: ['1f682'], keywords: ['Поезд'] },
        { name: 'Train', codes: ['1f686'], keywords: ['Поезд'] },
        { name: 'Metro', codes: ['1f687'], keywords: ['Метро'] },
        { name: 'Bus', codes: ['1f68c'], keywords: ['Автобус', 'Авто'] },
        { name: 'Trolleybus', codes: ['1f68e'], keywords: ['Троллейбус', 'Авто'] },
        { name: 'Ambulance', codes: ['1f691'], keywords: ['Здоровье', 'Скорая', 'Медицина'] },
        { name: 'Fire Engine', codes: ['1f692'], keywords: ['Пожар', 'Пожарная', 'Машина'] },
        { name: 'Police Car', codes: ['1f693'], keywords: ['Полиция', 'Милиция'] },
        { name: 'Taxi', codes: ['1f695'], keywords: ['Такси', 'Авто', 'Машина'] },
        { name: 'Automobile', codes: ['1f697'], keywords: ['Авто', 'Автомобиль', 'Машина'] },
        { name: 'Sport Utility Vehicle', codes: ['1f699'], keywords: ['Автомобиль'] },
        { name: 'Delivery Truck', codes: ['1f69a'], keywords: ['Грузовик'] },
        { name: 'Bicycle', codes: ['1f6b2'], keywords: ['Велосипед'] },
        { name: 'Kick Scooter', codes: ['1f6f4'], keywords: ['Скутер'] },
        { name: 'Motor Scooter', codes: ['1f6f5'], keywords: ['Мотороллер'] },
        { name: 'Sailboat', codes: ['26f5'], keywords: ['Путешествие', 'Отпуск', 'Яхта'] },
        { name: 'Canoe', codes: ['1f6f6'], keywords: ['Путешествие', 'Отпуск', 'Лодка'] },
        { name: 'Speedboat', codes: ['1f6a4'], keywords: ['Корабль', 'Лодка'] },
        { name: 'Passenger Ship', codes: ['1f6f3'], keywords: ['Корабль'] },
        { name: 'Motor Boat', codes: ['1f6e5'], keywords: ['Яхта'] },
        { name: 'Ship', codes: ['1f6a2'], keywords: ['Корабль', 'Лодка', 'Яхта'] },
        { name: 'Airplane', codes: ['2708'], keywords: ['Самолёт'] },
        { name: 'Small Airplane', codes: ['1f6e9'], keywords: ['Самолёт'] },
        { name: 'Helicopter', codes: ['1f681'], keywords: ['Вертолёт'] },
        { name: 'Rocket', codes: ['1f680'], keywords: ['Космос'] },
        { name: 'Flying Saucer', codes: ['1f6f8'], keywords: ['НЛО'] },
        { name: 'Bed', codes: ['1f6cf'], keywords: ['Кровать', 'Сон', 'Отдых'] },
        { name: 'Toilet', codes: ['1f6bd'], keywords: ['Туалет', 'Ванная комната'] },
        { name: 'Shower', codes: ['1f6bf'], keywords: ['Отпуск', 'Путешествие'] },
        { name: 'Bathtub', codes: ['1f6c1'], keywords: ['Ванная комната', 'Гигиена'] },
        { name: 'Hourglass Done', codes: ['231b'], keywords: ['Время', 'Часы'] },
        { name: 'Hourglass Not Done', codes: ['23f3'], keywords: ['Время', 'Часы'] },
        { name: 'Watch', codes: ['231a'], keywords: ['Время', 'Часы'] },
        { name: 'Alarm Clock', codes: ['23f0'], keywords: ['Время', 'Часы', 'Будильник'] },
        { name: 'Stopwatch', codes: ['23f1'], keywords: ['Время', 'Часы', 'Секундомер'] },
        { name: 'Crescent Moon', codes: ['1f319'], keywords: ['Лунный серп', 'Луна', 'Неомения'] },
        { name: 'Thermometer', codes: ['1f321'], keywords: ['Градусник'] },
        { name: 'Sun', codes: ['2600'], keywords: ['Погода', 'Ясно', 'Солнце'] },
        { name: 'Cloud', codes: ['2601'], keywords: ['Погода', 'Облака'] },
        { name: 'Sun Behind Cloud', codes: ['26c5'], keywords: ['Погода', 'Солнце', 'Облака'] },
        {
            name: 'Cloud With Lightning And Rain',
            codes: ['26c8'],
            keywords: ['Дождь', 'Гром', 'Гроза', 'Погода'],
        },
        { name: 'Sun Behind Small Cloud', codes: ['1f324'], keywords: ['Погода'] },
        { name: 'Sun Behind Large Cloud', codes: ['1f325'], keywords: ['Погода'] },
        { name: 'Sun Behind Rain Cloud', codes: ['1f326'], keywords: ['Погода'] },
        { name: 'Cloud With Rain', codes: ['1f327'], keywords: ['Погода', 'Дождь'] },
        { name: 'Cloud With Snow', codes: ['1f328'], keywords: ['Снег', 'Холодно', 'Погода'] },
        {
            name: 'Cloud With Lightning',
            codes: ['1f329'],
            keywords: ['Гроза', 'Молния', 'Гром', 'Погода', 'Стихия'],
        },
        { name: 'Tornado', codes: ['1f32a'], keywords: ['Ветер', 'Погода', 'Стихия'] },
        { name: 'Rainbow', codes: ['1f308'], keywords: ['Погода'] },
        { name: 'Umbrella', codes: ['2602'], keywords: ['Зонт', 'Дождь'] },
        { name: 'Umbrella on Ground', codes: ['26f1'], keywords: ['Зонт', 'Дождь'] },
        {
            name: 'Snowflake',
            codes: ['2744'],
            keywords: ['Снег', 'Холод', 'Холодно', 'Погода', 'Зима'],
        },
        { name: 'Snowman Without Snow', codes: ['26c4'], keywords: ['Зима'] },
        { name: 'Comet', codes: ['2604'], keywords: ['Космос'] },
        { name: 'Fire', codes: ['1f525'], keywords: ['Стихия'] },
        { name: 'Droplet', codes: ['1f4a7'], keywords: ['Вода'] },
    ],

    [EMOJI_CATEGORIES.ACTIVITIES]: [
        { name: 'Jack-O-Lantern', codes: ['1f383'], keywords: ['Тыква', 'Хэллоуин', 'Праздник'] },
        {
            name: 'Christmas Tree',
            codes: ['1f384'],
            keywords: ['Ёлка', 'Новый год', 'Праздник', 'Зима'],
        },
        { name: 'Balloon', codes: ['1f388'], keywords: ['Шар', 'Праздник'] },
        { name: 'Party Popper', codes: ['1f389'], keywords: ['Праздник', 'Поздравление'] },
        { name: 'Confetti Ball', codes: ['1f38a'], keywords: ['Праздник', 'Поздравление'] },
    ],

    [EMOJI_CATEGORIES.OBJECTS]: [
        { name: 'Money Bag', codes: ['1f4b0'], keywords: ['Деньги'] },
        { name: 'Yen Banknote', codes: ['1f4b4'], keywords: ['Япония', 'Деньги'] },
        { name: 'Dollar Banknote', codes: ['1f4b5'], keywords: ['Деньги'] },
        { name: 'Euro Banknote', codes: ['1f4b6'], keywords: ['Деньги'] },
        { name: 'Pound Banknote', codes: ['1f4b7'], keywords: ['Деньги'] },
        { name: 'Chart Increasing', codes: ['1f4c8'], keywords: ['График', 'Доход'] },
        { name: 'Chart Decreasing', codes: ['1f4c9'], keywords: ['График', 'Убыток'] },
        { name: 'Bar Chart', codes: ['1f4ca'], keywords: ['График'] },
    ],

    [EMOJI_CATEGORIES.SYMBOLS]: [
        { name: 'Up Arrow', codes: ['2b06'], keywords: ['Вверх', 'Стрелка'] },
        { name: 'Right Arrow', codes: ['27a1'], keywords: ['Вправо', 'Стрелка'] },
        { name: 'Down Arrow', codes: ['2b07'], keywords: ['Вниз', 'Стрелка'] },
        { name: 'Left Arrow', codes: ['2b05'], keywords: ['Влево', 'Стрелка'] },
        { name: 'Aries', codes: ['2648'], keywords: ['Овен', 'Зодиак'] },
        { name: 'Taurus', codes: ['2649'], keywords: ['Телец', 'Зодиак'] },
        { name: 'Gemini', codes: ['264a'], keywords: ['Близнецы', 'Зодиак'] },
        { name: 'Cancer', codes: ['264b'], keywords: ['Рак', 'Зодиак'] },
        { name: 'Leo', codes: ['264c'], keywords: ['Лев', 'Зодиак'] },
        { name: 'Virgo', codes: ['264d'], keywords: ['Дева', 'Зодиак'] },
        { name: 'Libra', codes: ['264e'], keywords: ['Весы', 'Зодиак'] },
        { name: 'Scorpius', codes: ['264f'], keywords: ['Скорпион', 'Зодиак'] },
        { name: 'Sagittarius', codes: ['2650'], keywords: ['Стрелец', 'Зодиак'] },
        { name: 'Capricorn', codes: ['2651'], keywords: ['Козерог', 'Зодиак'] },
        { name: 'Aquarius', codes: ['2652'], keywords: ['Водолец', 'Зодиак'] },
        { name: 'Pisces', codes: ['2653'], keywords: ['Рыбы', 'Зодиак'] },
        { name: 'Ophiuchus', codes: ['26ce'], keywords: ['Змееносец', 'Зодиак'] },
        { name: 'Female Sign', codes: ['2640'], keywords: ['Женщина'] },
        { name: 'Male Sign', codes: ['2642'], keywords: ['Мужчина'] },
        {
            name: 'White Heavy Check Mark',
            codes: ['2705'],
            keywords: ['Принято', 'Сделано', 'Готово', 'Выполнено', 'Есть', 'Done'],
        },
        {
            name: 'Heavy Check Mark',
            codes: ['2714'],
            keywords: ['Принято', 'Сделано', 'Готово', 'Выполнено', 'Есть'],
        },
        { name: 'Heavy Multiplication X', codes: ['2716'], keywords: ['Умножение'] },
        { name: 'Heavy Plus Sign', codes: ['2795'], keywords: ['сложения'] },
        { name: 'Heavy Minus Sign', codes: ['2796'], keywords: ['вычитания'] },
        { name: 'Heavy Division Sign', codes: ['2797'], keywords: ['Деление'] },
        { name: 'Double Exclamation Mark', codes: ['203c'], keywords: ['Восклицательный'] },
        { name: 'Exclamation Question Mark', codes: ['2049'], keywords: ['Восклицательный'] },
        { name: 'Question Mark', codes: ['2753'], keywords: ['Вопросительный'] },
        { name: 'Exclamation Mark', codes: ['2757'], keywords: ['Восклицательный'] },
        { name: 'Wavy Dash', codes: ['3030'], keywords: [] },
        { name: 'Copyright', codes: ['00a9'], keywords: ['копирайт'] },
        { name: 'Registered', codes: ['00ae'], keywords: ['Регистрация', 'Зарегистрирован'] },
        { name: 'Trade Mark', codes: ['2122'], keywords: ['Торговая марка'] },
        { name: 'Hundred Points', codes: ['1f4af'], keywords: ['100'] },
        { name: 'A Button (Blood Type)', codes: ['1f170'], keywords: [] },
        { name: 'AB Button (Blood Type)', codes: ['1f18e'], keywords: [] },
        { name: 'B Button (Blood Type)', codes: ['1f171'], keywords: [] },
        { name: 'Information', codes: ['2139'], keywords: [] },
        { name: 'O Button (Blood Type)', codes: ['1f17e'], keywords: [] },
        { name: 'OK Button', codes: ['1f197'], keywords: ['ОК'] },
        { name: 'SOS Button', codes: ['1f198'], keywords: ['сос'] },
        { name: 'UP! Button', codes: ['1f199'], keywords: ['ап'] },
    ],
};

export const KEYWORDS_MAP_BY_CATEGORIES = EMOJI_CATEGORIES_LIST.reduce((obj, category) => {
    obj[category] = {};

    return obj;
}, {});

const processEmojiEntity =
    (category) =>
    ({ keywords }, index) => {
        keywords.forEach((keyword) => {
            if (KEYWORDS_MAP_BY_CATEGORIES[category][keyword]) {
                KEYWORDS_MAP_BY_CATEGORIES[category][keyword].push(index);

                return;
            }

            KEYWORDS_MAP_BY_CATEGORIES[category][keyword] = [index];
        });
    };

Object.keys(KEYWORDS_MAP_BY_CATEGORIES).forEach((category) => {
    const emojiEntities = EMOJI_LIST_BY_CATEGORIES[category];

    emojiEntities.forEach(processEmojiEntity(category));
});

export const COMMON_EMOJI_CODES_MAP = {
    RAISED_HAND: '270b',
    RAISED_FIST: '270a',
};

export const EMOJI_SYMBOL_RAISED_HAND = '✋';

export const EMOJI_SYMBOL_BY_CODE_MAP = {
    '1f602': '😂',
    2764: '❤️',
    '1f44d': '👍',
    '1f44e': '👎',
    '1f389': '🎉',
};

function flattenEmojiList(emojiListByCategories) {
    const flattenedObject = {};

    Object.values(emojiListByCategories).forEach(emojiList => {
        emojiList.forEach(emoji => {
            const key = emoji.codes.join('_');
            flattenedObject[key] = emoji;
        });
    });

    return flattenedObject;
}

export const EMOJI_BY_CODE_MAP = flattenEmojiList(EMOJI_LIST_BY_CATEGORIES);

export const MESSAGE_EMOJI_SRC = (emojiCodePoints) => `${window.cdnHost || ''}/event/static/images/emoji/png/emoji_u${emojiCodePoints}.png`;
